var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_793",
    "data-name": "Group 793",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_956",
    "data-name": "Rectangle 956",
    width: 40,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M35,0H5A5,5,0,0,0,0,5V25a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5",
    fill: "#2e3235"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M9.068,14.019a1.2,1.2,0,0,1-1.279-1.108,1.356,1.356,0,0,1,0-.142,1.616,1.616,0,0,1,1.589-1.636,1.213,1.213,0,0,1,1.276,1.146,1.043,1.043,0,0,1,0,.125A1.588,1.588,0,0,1,9.09,14.018H9.068m.44-4.348a3.309,3.309,0,0,0-3.466,3.144l0,.034A2.681,2.681,0,0,0,8.946,15.5a3.334,3.334,0,0,0,3.463-3.2v-.01a2.645,2.645,0,0,0-2.9-2.61",
    transform: "translate(1.51 2.417)",
    fill: "#e5e5e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M18.563,14.019a1.2,1.2,0,0,1-1.274-1.114.991.991,0,0,1,0-.136,1.614,1.614,0,0,1,1.588-1.636,1.213,1.213,0,0,1,1.276,1.146,1.042,1.042,0,0,1,0,.125,1.587,1.587,0,0,1-1.561,1.614h-.028M19,9.672a3.308,3.308,0,0,0-3.461,3.15v.028A2.68,2.68,0,0,0,18.447,15.5a3.342,3.342,0,0,0,3.464-3.214,2.639,2.639,0,0,0-2.9-2.61Z",
    transform: "translate(3.885 2.417)",
    fill: "#e5e5e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M23.542,12.4h-.26l.2-1.165h.234c.529,0,.836.164.836.53s-.414.635-1.006.635m2.806-.916c0-1.059-.821-1.715-2.3-1.715h-2.1l-.91,5.57H22.8l.291-1.753h.079l.932,1.753h2.023l-1.3-1.949a2.023,2.023,0,0,0,1.52-1.906",
    transform: "translate(5.261 2.442)",
    fill: "#e5e5e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M5.048,12.016c-.668-.339-.821-.429-.821-.6s.265-.339.636-.339a2.284,2.284,0,0,1,1.694.646A3.6,3.6,0,0,1,7.3,10.432,5.151,5.151,0,0,0,4.83,9.671c-1.5,0-2.365.8-2.365,1.763,0,.826.629,1.26,1.375,1.641s.836.445.836.656-.28.35-.651.35a3.014,3.014,0,0,1-1.836-.815l-.255,1.551a3.483,3.483,0,0,0,2.119.666c1.556,0,2.392-.778,2.392-1.779-.005-.81-.545-1.239-1.4-1.689",
    transform: "translate(0.484 2.418)",
    fill: "#e5e5e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M15.711,12.209H13.646l.164-.98h2.214a3.8,3.8,0,0,1,1.281-1.44H13.684a1.59,1.59,0,0,0-1.589,1.281l-.71,4.289h1.764l.291-1.752h2.117l.149-.953a1.227,1.227,0,0,1,0-.445",
    transform: "translate(2.846 2.447)",
    fill: "#e5e5e0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M25.321,9.79a2.084,2.084,0,0,1,.821,1.466h1.471l-.678,4.1H28.7l.657-4.13h1.63l.265-1.44Z",
    transform: "translate(6.33 2.447)",
    fill: "#e5e5e0",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofort);
export default __webpack_public_path__ + "static/media/sofort.1d2c4eb19419101870bdc92a4559c524.svg";
export { ForwardRef as ReactComponent };